import { asJSON, objEqual } from './util';
import * as gemini from "gemini/gemini.web";

function paramToOpt(recomParameters) {
  const dataJoinKey = recomParameters.dataJoinKey === "" ? undefined : recomParameters.dataJoinKey.split(";").map(key => key.trim())
  const xDomainChange = recomParameters.xScaleDomainDimension === "default" ? undefined : recomParameters.xScaleDomainDimension;
  const yDomainChange = recomParameters.yScaleDomainDimension === "default" ? undefined : recomParameters.yScaleDomainDimension;

  return {
    marks: { marks: { change: { data: dataJoinKey } } },
    scales: {
      x: xDomainChange ? { domainDimension: xDomainChange } : {},
      y: yDomainChange ? { domainDimension: yDomainChange } : {}
    },
    stageN: recomParameters.stageN,
    includeMeta: false, //Todo
    totalDuration: recomParameters.duration || 2000
  }
}
function optToParam(opt) {
  let newParams = {
    xScaleDomainDimension: "default",
    yScaleDomainDimension: "default",
    stageN: (opt && opt.stageN) ? opt.stageN : 1,
    duration: opt.totalDuration || 2000
  };
  if (opt && opt.marks && opt.marks.marks && opt.marks.marks.change) {
    newParams.dataJoinKey = (opt.marks.marks.change.data || []).join(";");
  }

  if (opt && opt.scales && opt.scales.x && opt.scales.x.domainDimension) {
    newParams.xScaleDomainDimension = opt.scales.x.domainDimension;
  }

  if (opt && opt.scales && opt.scales.y && opt.scales.y.domainDimension) {
    newParams.yScaleDomainDimension = opt.scales.y.domainDimension;
  }
  return newParams;
}
function setUserInput(userInput) {

  this.setState({
    recomParameters: {
      ...this.state.recomParameters,
      ...optToParam(userInput)
    }
  });
}


async function updateRecomParameters(paramChange) {
  let newParams = {...this.state.recomParameters, ...paramChange};
  let sSpec = gemini.castVL2VG(asJSON(this.state.sSpecText) || {}),
    eSpec = gemini.castVL2VG(asJSON(this.state.eSpecText) || {});
  let newRecoms = await gemini.recommend(
    sSpec,
    eSpec,
    paramToOpt(newParams)
  );
  this.setState({
    recomParameters: newParams,
    recoms: newRecoms,
    recom: {sSpec, eSpec}
  })
}

function onRecomHide() {
  this.setState({recomModalShow: false});
}
async function showRecom() {
  let sSpec = gemini.castVL2VG(asJSON(this.state.sSpecText) || {}),
    eSpec = gemini.castVL2VG(asJSON(this.state.eSpecText) || {});
  if (
    (!objEqual(this.state.recom.sSpec, sSpec))
    || (!objEqual(this.state.recom.eSpec, eSpec))
  ) {
    let stageN = this.state.recomParameters.stageN;
    let recoms = await gemini.recommend(
      sSpec,
      eSpec,
      paramToOpt(this.state.recomParameters)
    );
    if (recoms.error) {
      stageN = 1;
      recoms = await gemini.recommend(
        sSpec,
        eSpec,
        {
          ...paramToOpt(this.state.recomParameters),
          stageN
        }
      );
    }


    this.setState({
      recomParameters: {
        ...this.state.recomParameters,
        stageN
      },
      recoms: recoms,
      recom: {sSpec, eSpec},
      recomModalShow: true
    });
  } else {
    this.setState({ recomModalShow: true });
  }
}

export {
  setUserInput,
  optToParam,
  paramToOpt,
  updateRecomParameters,
  showRecom,
  onRecomHide
}